import { merge, get } from 'lodash';
import { getType } from 'typesafe-actions';

import storage from '@lib/services/storageService';
import { RESFRESH_CURRENT_USER } from 'containers/App/constants';
import { SIGN_IN, VALIDATE_TOKEN, FETCH_CURRENT_USER } from '@lib/actions/actionTypes';
import { initApp, signOut } from '@lib/actions';

const initialState = {
  ready: false,
  user: undefined,
  master: undefined,
};

export default function createAuthReducer() {
  return (state = initialState, action) => {
    switch (action.type) {
      case RESFRESH_CURRENT_USER: {
        if (action.isToRefreshAuth) {
          const auth = merge({}, state, {
            ready: true,
            user: action.user._id,
            master: action.user._id,
          });
          return merge({}, state, auth);
        }
        return state;
      }
      // SIGN_IN / SIGN_OUT
      case SIGN_IN.REQUEST:
      case getType(signOut):
        return initialState;
      case SIGN_IN.SUCCESS: {
        storage.setUser(action.data);
        return merge({}, state, {
          user: get(action, 'data._id', ''),
        });
      }
      // VALIDATE_TOKEN
      case VALIDATE_TOKEN.SUCCESS:
        return merge({}, state, {
          user: action.normalized.result,
        });
      // FETCH_CURRENT_USER
      case FETCH_CURRENT_USER.SUCCESS:
        return merge({}, state, {
          user: get(action, 'data._id', ''),
          master: action.data.user,
        });
      // initApp.success
      case getType(initApp.success):
        return merge({}, state, action.payload, { ready: true });
      default:
        return state;
    }
  };
}
